import React from 'react';

const ServicesDeveloperPod = () => (
  <div>
    <div className="developer-pod-container">
      <div className="developer-services-copy">
        <h1 id="customWebsite">Custom Website Themes and Applications</h1>
        <p>
          When creating a website or application, the usual strategy is to use a design file. Then it is built, while
          working in a development testing environment. Once that phase has been complete, it can then be turned into a
          compressed production build, which is ready for deployment to online servers. For this process, I use the
          programming languages HTML5, CSS3, Stylus/Sass and JavaScript.
        </p>
        <h2>Development Production Build Phases</h2>
        <p>
          Phase 1: Development Build<br />
          Phase 2: Production Build
        </p>
        <h2>HTML5</h2>

        <p>
          I use HTML5 for building the overall structure of the website. It is basically the skeleton part of the design
          phase.
        </p>

        <h2>CSS3</h2>

        <p>
          A lot of people tend to use a CSS framework, which is basically a custom made template that makes it simple,
          for creating designs because it has a built in grid system. These days, I prefer to use the CSS Grid and
          Flexbox layout systems for scaffolding the designs of websites, and applications that I create. In my opinion
          their combined power has made traditional CSS frameworks, like Bootstrap completely optional because, there is
          no bloatware and you have full control, of everything that you create. I use CSS3 for the colours, styles and
          animations.
        </p>

        <h2>CSS Preprocessors</h2>

        <p>
          I use Stylus or Sass. It just makes the whole process cleaner, and more compatible with web browsers old,
          current and new. It makes the website, or application easier to maintain, which means less errors and faster
          problem solving.
        </p>

        <h2>JavaScript</h2>

        <p>
          I use JavaScript, when I want to add functionality to websites and applications. This can be in the form of
          interactivity, such as image carousels and buttons. As well as events, when a user interacts with elements on
          the webpage. Like a drop down menu, and even animations.
        </p>

        <p>
          Currently I am working with one of the latest releases called, JavaScript ES2015. This means that I can use
          future technologies, in current modern browsers today and, it is backwards compatible.
        </p>
        <h1 id="dynamicWebsites">Dynamic Websites and Applications</h1>
        <p>
          For making it dynamic, I like to work with the front end Javascript frameworks, React or Vue. I use them in
          combination with the developer tools to complete my workflow.
        </p>

        <h2>React and Vue</h2>

        <p>
          These are the Javascript frameworks, I use for building the user interfaces in my applications. They allow for
          a very clean, and easy way for rendering designs, which have been developed for web browsers and mobile
          devices. React and Vue, also work with other third party libraries and frameworks, which makes them powerful
          tools. This means, lots of advanced configurations. I use their, development servers, to prototype in native
          browsers and mobile devices.
        </p>

        <h2>NodeJS npm/yarn</h2>

        <p>
          NodeJS is a JavaScript runtime environment, which runs on the computer command-line. It is a console user
          interface, where you can issue commands to computer programs. This serves as the basis, for my entire
          development workflow. It is how I build everything.
        </p>

        <p>
          npm and yarn are ecosystems of open source libraries. These are packages of reusable code, which extend
          functionality to the applications, that i build by adding new features and tools.
        </p>

        <h2>Webpack</h2>

        <p>
          Webpack is the build system, I use for converting developer builds, of my work into production ready ones
          which, can then be deployed to servers. This is the final phase after all of the testing has been completed.
          It is also how I test my applications locally, as it has a built in local server.
        </p>

        <h2>GIT</h2>

        <p>
          GIT is the tool I use for version controlling all the work that I do. Basically this means that I can,
          rollback to an earlier more stable version if there are problems with current, and future releases. It also
          allows me to keep a log and track, every single amend and update I do.
        </p>
        <h1 id="w3c">W3C Web Standards</h1>
        <p>
          These are guidelines which all web developers are supposed to follow. I try to make sure that, the website has
          a very clean mark up language which remains consistent. This helps to future proof the application, leading to
          less compatibility problems in browsers.
        </p>
        <h1 id="seo">Search Engine Optimisation (SEO)</h1>
        <p>
          Search Engine Optimisation, is the creative process which improves the visibility of websites, within a search
          engine like Google. It is one of the most important phases because without it, finding your website would be
          significantly more difficult and this, is a problem when you are trying to get customers and exposure locally
          and globally.
        </p>
        <h1 id="analytics">Analytics and Reports</h1>
        <p>When it comes to data analysis, I use the tools Google Analytics and hotjar. </p>

        <h2>Google Analytics</h2>

        <p>
          Google Analytics is a very useful tool which, uses web analytics to track and report website traffic. With
          this information you can see which pages get the most website traffic, and what devices they were using. With
          this information, you can better cater to your customers.
        </p>

        <h2>hotjar</h2>

        <p>
          With this tool you can accurately see where your website visitors interacted on your website, giving you a
          visual representation of all their user actions and page scrolling behaviour. The various analysis features
          mean, that you can figure out what areas of your website, are most popular giving you an idea of what, design
          choices are working and, which ones need improvement.
        </p>
        <h1 id="websiteUpgrade">Website Upgrade</h1>

        <p>
          I can transfer your old and existing website, to a new website hosting package. Website hosting providers
          allow you to buy online space on their web servers which, is the equivalent to having space on your computer
          hard drive. The difference is that on their online servers, you will be able to share and access your website
          files from anywhere in the world, not just your local computer.
        </p>

        <p>
          A domain name will be required to access your website and this, can be set up too. Its basically the unique
          identifier that you type into your browsers search box which, then directs you to the website address. It is
          called a Domain Name System (DNS).
        </p>
        <h1 id="debug">Debugging and Testing</h1>
        <p>
          It’s always possible that errors and problems might occur at some stage. I use native web browser developer
          tools and, code linting which checks for programming syntax errors.
        </p>
        <h1 id="support">Technical Support</h1>
        <p>I can offer technical support for any problems you have via IM, email, and phone calls.</p>
      </div>
    </div>
  </div>
);

export default ServicesDeveloperPod;
